import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { ServiceFormComponent } from '../service-form/service-form.component';
import * as _ from 'underscore';
import { MatTableDataSource } from '@angular/material/table';
import { IService } from '../service.interface';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-service-view',
    templateUrl: './service-view.component.html',
    styleUrls: ['./service-view.component.less'],
    standalone: false
})
export class ServiceViewComponent implements OnInit {

  serviceForm: FormGroup;
  dataSource = new MatTableDataSource<IService>();
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalServiceRecords: number;
  subscription = new Subscription();
  addPermission = false;
  editPermission = false;
  viewPermission = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['serviceCode', 'serviceDescription', 'action'];

  constructor(
    private fb: FormBuilder,
    private service: DataService,
    private dialog: MatDialog,
    private utilityService: UtilityService,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.handleServiceDescriptionSearch();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.paginator?.page?.pipe(tap(() => this.getServices())).subscribe();
    this.getServices();
  }

  private initializeForm(): void {
    this.serviceForm = this.fb.group({
      serviceCode: [],
      serviceDescription: []
    });
  }

  private getServices(): void {
    if (!this.viewPermission) return;

    const criteria: any = {
      page: this.paginator?.pageIndex,
      size: this.paginator?.pageSize
    };

    if (this.serviceForm?.value?.serviceDescription) {
      criteria['serviceDescription.contains'] =
        this.serviceForm.value.serviceDescription;
    }

    this.service.get(Api.SERVICE_MASTER, criteria).subscribe(res => {
      this.dataSource.data = res?.contents || [];
      this.totalServiceRecords = res.totalRecords;
    });
  }


  private handleServiceDescriptionSearch(): void {
    const sub = this.serviceForm
      .get('serviceDescription')
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.paginator.pageIndex = 0;
        this.getServices();
      });

    this.subscription.add(sub);
  }


  openForm(row?: any): void {
    if (!this.addPermission && !row) return;
    if (!this.editPermission && row) return;

    const ref = this.dialog.open(ServiceFormComponent, {
      data: row,
      width: '650px',
      maxWidth: '90vw',
      disableClose: true,
      autoFocus: false
    });

    ref.afterClosed().subscribe(() => this.getServices());
  }

  isDuplicateRow(row: IService): boolean {
    const data = this.dataSource.data;
    const codeCount = data.filter(item => item.serviceCode === row.serviceCode).length;
    const descCount = data.filter(item => item.serviceDescription === row.serviceDescription).length;
    return codeCount > 1 || descCount > 1;
  }

  clearServiceDescriptionSearch(): void {
    this.serviceForm.get('serviceDescription')?.setValue('');
    this.paginator.pageIndex = 0;
    this.getServices();
  }


  private checkAllPermission(): void {
    const permissions = this.permissionService.checkPermissions(
      [
        PermissionKey.SERVICE_MODULE_ADD_PERMISSION,
        PermissionKey.SERVICE_MODULE_EDIT_PERMISSION,
        PermissionKey.SERVICE_MODULE_VIEW_PERMISSION
      ],
      PermissionKey.SERVICE_MODULE
    );

    this.addPermission = _.findWhere(permissions, { permissionCode: PermissionKey.SERVICE_MODULE_ADD_PERMISSION })?.show;
    this.editPermission = _.findWhere(permissions, { permissionCode: PermissionKey.SERVICE_MODULE_EDIT_PERMISSION })?.show;
    this.viewPermission = _.findWhere(permissions, { permissionCode: PermissionKey.SERVICE_MODULE_VIEW_PERMISSION })?.show;
  }
}
